import { useUIStore, ViewName } from '@/state/store';

const STATES: { id: ViewName; label: string }[] = [
  { id: 'login', label: 'Login' },
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'incoming', label: 'Incoming' },
  { id: 'incall', label: 'In-Call' },
  { id: 'incall-doc-focus', label: 'Doc-Cam Focus' },
  { id: 'incall-inspection', label: 'Inspection' },
  { id: 'incall-translation', label: 'Translation' },
  { id: 'incall-recording', label: 'Recording' },
  { id: 'incall-turn-warn', label: 'TURN-Warn' },
  { id: 'wrap', label: 'Nachbereitung' },
];

export function StateBanner() {
  const view = useUIStore((s) => s.view);
  const setView = useUIStore((s) => s.setView);

  return (
    <div className="banner">
      <div className="brand-tag">BAMOA BERATER · V2 · PRO COCKPIT</div>
      <div className="state-pills">
        {STATES.map((s) => (
          <button
            key={s.id}
            className={view === s.id ? 'active' : ''}
            onClick={() => setView(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
